module.exports = __webpack_public_path__ + "static/media/_page.b826b78f.png";